import { Link } from "react-router-dom";
import { useRef } from "react";
import { inr } from "@/lib/api";
import { Heart } from "lucide-react";
import { useApp } from "@/context/AppContext";
import { toast } from "sonner";

export default function ProductCard({ p }) {
  const { toggleWishlist, isWished } = useApp();
  const off = p.original_price ? Math.round(((p.original_price - p.price) / p.original_price) * 100) : 0;
  const wished = isWished(p.id);
  const ref = useRef(null);

  const onMove = (e) => {
    const el = ref.current; if (!el) return;
    const r = el.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width;
    const y = (e.clientY - r.top) / r.height;
    const rx = (0.5 - y) * 10; // rotate X
    const ry = (x - 0.5) * 14; // rotate Y
    el.style.transform = `perspective(1100px) rotateX(${rx}deg) rotateY(${ry}deg) translateZ(0)`;
  };
  const onLeave = () => {
    const el = ref.current; if (!el) return;
    el.style.transform = `perspective(1100px) rotateX(0deg) rotateY(0deg) translateZ(0)`;
  };

  const onHeart = (e) => {
    e.preventDefault(); e.stopPropagation();
    toggleWishlist(p);
    toast.success(wished ? "Removed from wishlist" : "Added to wishlist");
  };

  return (
    <div className="perspective-1200">
      <Link
        to={`/product/${p.id}`}
        data-testid={`product-card-${p.id}`}
        ref={ref}
        onMouseMove={onMove}
        onMouseLeave={onLeave}
        className="product-card tilt-card group block"
      >
        <div className="relative overflow-hidden rounded-md bg-[#2A231D] aspect-[3/4] border border-[#D4B25C]/10">
          {(p.tags || []).includes("new") && (
            <span className="absolute top-3 left-3 bg-[#0A0A0A] text-[#D4B25C] text-[10px] font-bold px-2 py-1 tracking-widest border border-[#D4B25C]/40 tilt-inner">
              NEW
            </span>
          )}
          {off > 0 && (
            <span className={`absolute ${(p.tags || []).includes("new") ? "top-10" : "top-3"} left-3 bg-[#8B2E2E] text-white text-[10px] font-bold px-2 py-1 tracking-widest tilt-inner`}>
              {off}% OFF
            </span>
          )}
          <button
            data-testid={`wishlist-${p.id}`}
            onClick={onHeart}
            className={`absolute top-3 right-3 h-9 w-9 rounded-full flex items-center justify-center transition-colors tilt-inner ${wished ? "bg-[#8B2E2E] text-white" : "bg-[#0F0B08]/70 backdrop-blur-md text-[#F0E5D0] hover:bg-[#8B2E2E] hover:text-white"}`}
            aria-label="Wishlist"
          >
            <Heart size={16} fill={wished ? "currentColor" : "none"} />
          </button>
        </div>
        <div className="pt-3">
          <p className="label-tag">{p.subcategory}</p>
          <h3 className="font-display text-lg leading-tight mt-1 group-hover:text-[#D4B25C] transition-colors">{p.name}</h3>
          <div className="flex items-baseline gap-2 mt-1">
            <span className="font-extrabold text-gold">{inr(p.price)}</span>
            {p.original_price && <span className="text-xs text-muted-foreground line-through">{inr(p.original_price)}</span>}
          </div>
        </div>
      </Link>
    </div>
  );
}
